export default function downloadFile(buffer: ArrayBuffer, mimeType: string, filename: string) {
  const blob = new Blob([ buffer ], { type: mimeType });
  const link = document.createElement('a');
  link.download = filename;
  link.href = window.URL.createObjectURL(blob);
  link.click();
}
